export default __webpack_public_path__ + "static/media/rainforest4.1b36b4e8.jpg";